module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Light.53d650a3.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Light.eot
// module id = 85
// module chunks = 3